import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { MiembroComiteType } from '../components/Concursos/Gestion/ConfeccionPrimerActa/GenerarAprobacion/ComiteMiembrosPopup';
import { RolComite } from '../components/Concursos/Gestion/TramitarConcursos/Commons/ComiteTable/ComiteRow';
import { NuevoComiteFormValues } from '../components/Concursos/Gestion/TramitarConcursos/Commons/ComiteTable/NuevoComiteMiembro';
import { UsuarioProps } from '../components/Usuario/UpdateUser';
import { CONCURSOAPI, ROLES_COMITE_ID, USERAPI } from '../const';

const sliceName = 'comiteMiembros';

type State = {
  miembros: null | MiembroComiteType[];
  error: string;
  loading: boolean;
  success: string;
  file: string;
  usuario?: null | UsuarioProps;
  successAdd: boolean;
};
const initialState: State = {
  miembros: null,
  error: '',
  loading: false,
  success: '',
  file: '',
  successAdd: false,
};

type GetValues = { idLlamadoConcurso: number };
export const getComiteMiembros = createAsyncThunk<MiembroComiteType[], GetValues>(
  `${sliceName}/get`,
  async ({ idLlamadoConcurso }) => {
    const mapRol = (comitRol: number) => {
      switch (comitRol) {
        case ROLES_COMITE_ID.ASESOR_TEMATICO:
          return 'Aesor temático';
        case ROLES_COMITE_ID.CC:
          return 'Coordinador Concursal';
        case ROLES_COMITE_ID.EXTERNO:
          return 'Externo';
        case ROLES_COMITE_ID.INTERNO:
          return 'Interno';
        case ROLES_COMITE_ID.ORGANO_RECTOR:
          return 'Órgano Rector';
        case ROLES_COMITE_ID.VEEDOR:
          return 'Veedor';
        default:
          return '';
      }
    };

    const resp = await axios.get(`${CONCURSOAPI}/llamadoconcurso/comites`, {
      params: { idLlamadoConcurso },
    });
    const [first] = resp.data;
    const { usuario } = first;

    const final = Object.keys(usuario)
      .reduce((acc, it): any => {
        const usuarios = usuario[it].map((e: any) => ({ ...e, comite_rol: parseInt(it) }));
        return [...acc, ...usuarios];
      }, [])
      .map((e: any) => ({ ...e, comite_rol_nombre: mapRol(e.comite_rol) }));

    return final;
    // return usuario[];
  },
);

export const getComiteMiembrosPublico = createAsyncThunk<MiembroComiteType[], GetValues>(
  `${sliceName}/get`,
  async ({ idLlamadoConcurso }) => {
    const mapRol = (comitRol: number) => {
      switch (comitRol) {
        case ROLES_COMITE_ID.ASESOR_TEMATICO:
          return 'Aesor temático';
        case ROLES_COMITE_ID.CC:
          return 'Coordinador Concursal';
        case ROLES_COMITE_ID.EXTERNO:
          return 'Externo';
        case ROLES_COMITE_ID.INTERNO:
          return 'Interno';
        case ROLES_COMITE_ID.ORGANO_RECTOR:
          return 'Órgano Rector';
        case ROLES_COMITE_ID.VEEDOR:
          return 'Veedor';
        default:
          return '';
      }
    };

    const resp = await axios.get(`${CONCURSOAPI}/concursos-publicados/comite/${idLlamadoConcurso}`);
    const [first] = resp.data;
    const { usuario } = first;
    const final = Object.keys(usuario)
      .reduce((acc, it): any => {
        const usuarios = usuario[it].map((e: any) => ({ ...e, comite_rol: parseInt(it) }));
        return [...acc, ...usuarios];
      }, [])
      .map((e: any) => ({ ...e, comite_rol_nombre: mapRol(e.comite_rol) }));

    return final;
    // return usuario[];
  },
);

type GetCvProps = { idUsuario: number };
export const getCV = createAsyncThunk<string, GetCvProps>(
  `${sliceName}/get/cv`,
  async ({ idUsuario }) => {
    const { data } = await axios.get(`${USERAPI}/usuarios/file/${idUsuario}`, {
      responseType: 'blob',
    });

    const file = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(file);

    return url;
  },
);

export const getCVPublico = createAsyncThunk<string, GetCvProps>(
  `${sliceName}/get/cvPublico`,
  async ({ idUsuario }) => {
    const { data } = await axios.get(`${USERAPI}/public/usuarios/${idUsuario}/cv`, {
      responseType: 'blob',
    });

    const file = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(file);
    return url;
  },
);

type GetUsuarioComiteProps = { cuil: string };
export const getUsuarioComite = createAsyncThunk<UsuarioProps, GetUsuarioComiteProps>(
  `${sliceName}/get/usuario`,
  async ({ cuil }) => {
    const { data } = await axios.get(`${USERAPI}/usuarios/cuil/${cuil}`);
    return data;
  },
);

type AddUsuarioProps = {
  usuario: UsuarioProps | null;
  valores: NuevoComiteFormValues;
  rolComite: RolComite;
};
export const addUsuarioComite = createAsyncThunk<MiembroComiteType, AddUsuarioProps>(
  `${sliceName}/add/usuario`,
  async ({ usuario, valores, rolComite }, { getState }) => {
    const toMiembro = (user: UsuarioProps): MiembroComiteType => ({
      ...user,
      ...valores,
      pathCvProvisto: valores.pathCvProvisto as string,
      titular: valores.titular === '1',
      comite_rol: rolComite.idRolComite,
      comite_rol_nombre: rolComite.nombre,
      idUsuarioComite: 1,
    });

    const { pathCvProvisto, dni, cuil, apellido, nombre, email, telefono } = valores;

    const { comite } = getState() as any;
    const miembros = comite.miembros as MiembroComiteType[];
    const exists = miembros.find((e) => e.cuil === cuil);
    if (exists) throw Error('El usuario ya existe en el comité');

    if (!usuario) {
      //Nuevo Usuario
      const finalUser = { dni, cuil, apellido, nombre, email, telefono };
      const formData = new FormData();
      formData.append('cv', pathCvProvisto);
      formData.append('userData', JSON.stringify(finalUser));
      await axios.post(`${USERAPI}/auth/signup-simple`, formData);
    } else if (pathCvProvisto instanceof File) {
      //CV Actualizado
      const formDataCv = new FormData();
      formDataCv.append('file', pathCvProvisto);
      formDataCv.append('cuil', cuil);

      await axios.post(`${USERAPI}/auth/upload`, formDataCv);
    }

    return toMiembro({ ...usuario, ...valores } as any);
  },
);

type ConfirmarProps = { idComite: number; idLlamadoConcurso: number };
export const confirmarComite = createAsyncThunk<void, ConfirmarProps>(
  `${sliceName}/post/confirmar`,
  async ({ idComite, idLlamadoConcurso }, { getState }) => {
    const state = getState() as any;
    const comite = state.comite as State;
    const { miembros } = comite;

    const parseMiembros = () => {
      const toFinal = (user: any) => ({
        idUsuario: user.idUsuario,
        titular: user.titular,
        representacion: user.representacion || undefined,
      });

      return (miembros ?? [])?.reduce<any>((acc, it) => {
        const porRol = acc[it.comite_rol as any];
        if (porRol) porRol.push(toFinal(it));
        else {
          acc[it.comite_rol] = [toFinal(it)];
        }

        return acc;
      }, {});
    };

    const postData = { idComite, idLlamadoConcurso, usuarios: parseMiembros() };
    await axios.put(`${CONCURSOAPI}/llamadoconcurso/comites`, postData);
  },
);

const comiteMiembrosSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    cleanMsg: (state) => ({ ...state, success: '', error: '', successAdd: false }),
    cleanCV: (state) => ({ ...state, file: '' }),
    cleanUsuario: (state) => ({ ...state, usuario: undefined }),
    cleanState: () => ({
      loading: false,
      miembros: null,
      success: '',
      error: '',
      file: '',
      successAdd: false,
    }),
    removeUsuarioComite: (state, action) => {
      const { cuil } = action.payload;
      state.miembros = (state.miembros ?? [])?.filter((e) => e.cuil !== cuil);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getComiteMiembros.pending, (state) => {
      state.miembros = [];
      state.loading = true;
    });
    builder.addCase(getComiteMiembros.fulfilled, (state, action) => {
      return { ...state, loading: false, miembros: action.payload };
    });
    builder.addCase(getComiteMiembros.rejected, (state, action) => {
      return { ...state, loading: false, error: 'No se pudo obtener el comité' };
    });

    builder.addCase(getCV.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCV.fulfilled, (state, action) => {
      state.loading = false;
      state.file = action.payload;
    });
    builder.addCase(getCV.rejected, (state) => {
      return { ...state, loading: false, error: 'No se pudo recuperar el archivo' };
    });
    builder.addCase(getCVPublico.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCVPublico.fulfilled, (state, action) => {
      state.loading = false;
      state.file = action.payload;
    });
    builder.addCase(getCVPublico.rejected, (state) => {
      return { ...state, loading: false, error: 'No se pudo recuperar el archivo' };
    });

    builder.addCase(getUsuarioComite.pending, (state) => {
      state.loading = true;
      state.usuario = undefined;
    });
    builder.addCase(getUsuarioComite.fulfilled, (state, action) => {
      state.loading = false;
      state.usuario = action.payload;
    });
    builder.addCase(getUsuarioComite.rejected, (state) => {
      return { ...state, loading: false, usuario: null };
    });

    builder.addCase(addUsuarioComite.pending, (state) => {
      state.loading = true;
      state.successAdd = false;
    });

    builder.addCase(addUsuarioComite.fulfilled, (state, action) => {
      let miembros = state.miembros ?? [];

      state.miembros = miembros.concat(action.payload);
      state.loading = false;
      state.successAdd = true;
    });

    builder.addCase(addUsuarioComite.rejected, (state, action) => {
      state.loading = false;
      state.error = 'El usuario ya existe en el comité';
    });

    builder.addCase(confirmarComite.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(confirmarComite.fulfilled, (state) => {
      state.loading = false;
      state.success = 'El comité se actualizó correctamente';
    });
  },
});

export const useComite = () => useSelector((state: any) => state.comite) as State;
export const { cleanMsg, cleanState, cleanCV, cleanUsuario, removeUsuarioComite } =
  comiteMiembrosSlice.actions;
const comiteMiembrosReducer = comiteMiembrosSlice.reducer;
export default comiteMiembrosReducer;
